.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  padding: 1rem;
}

.card {
  width: 100%;
  max-width: 380px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 2.5rem 2rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.75rem;
}

.logoIcon {
  font-size: 1.4rem;
  background: var(--grad-brand);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logoName {
  font-family: var(--font-mono);
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text);
  letter-spacing: -0.01em;
}

.heading {
  font-size: 1.375rem;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 0.25rem;
}

.hint {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  margin: 0 0 1.25rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.label {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--color-text-muted);
  letter-spacing: 0.02em;
}

.input {
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  color: var(--color-text);
  font-family: var(--font-sans);
  font-size: 0.9375rem;
  padding: 0.625rem 0.75rem;
  outline: none;
  transition: border-color 0.15s;
}

.input:focus {
  border-color: var(--color-sky);
}

.input:disabled {
  opacity: 0.5;
}

.error {
  font-size: 0.8125rem;
  color: var(--color-error);
  margin: 0;
}

.btn {
  margin-top: 0.5rem;
  padding: 0.6875rem 1rem;
  background: var(--grad-brand);
  border: none;
  border-radius: 6px;
  color: #040D18;
  font-family: var(--font-sans);
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn:not(:disabled):hover {
  opacity: 0.9;
}

.passwordWrap {
  position: relative;
  display: flex;
  align-items: center;
}

.passwordWrap .input {
  width: 100%;
  padding-right: 2.5rem;
}

.eyeBtn {
  position: absolute;
  right: 0.625rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  line-height: 1;
}

.eyeBtn:hover {
  color: var(--color-text);
}
